/** Body payload for the get vehicle request. */
export class GetVehicleRequestBody {
  /** Vehicle identification number/chassis number (17 characters). */
  vin: string;
}
